// extracted by mini-css-extract-plugin
export var equalColumn = "_es-0";